module.exports = __webpack_public_path__ + "img/prestamo.5d61a8af.png";